module.exports = __webpack_public_path__ + "static/media/5.c8d96811.jpg";